
<div class="row" *ngIf="annonce">
  <div class="col-md-12">

    <div *ngIf="config('annonce_template')?._view === true" class="row">
      <div class="col-12 ml-auto mr-auto">
        <div [hover-class]="config('annonce_template')?.param2" [class]="oneBlock ? 'card' : 'card card-plain'">
          <div id="title" class="card-header card-header-rose">
            <h1 class="card-title" style="text-align: center;">{{ annonce.intitule  | uppercase}}</h1>
          </div>
          <div class="card-body">
            <section class="row d-flex flex-row tm-pt-4 tm-pb-6">
              <div class="col-12 text-center align-self-center my-auto align-items-center tm-page-cols-container">
                <img [src]="annonce.societe_logo" [style]="safeCss(config('annonce_template')?.style)" />
              </div>
            </section>
          </div>
        </div>
      </div>
      <ng-content *ngTemplateOutlet="content"></ng-content>
    </div>

    <div *ngIf="config('annonce_template')?._view === false" [class]="oneBlock ? 'card' : 'card card-plain'">
      <div [style]="safeCss(config('cards_colors')?.style)"id="title" [class]="config('card_title')?.class ? 'card-header ' + config('card_title')?.class : 'card-header'">
        <h1 [class]="config('card_title')?.param1 ? 'card-title ' + config('card_title')?.param1 : 'card-title'" style="text-align: center;">{{ annonce.intitule }}</h1>
      </div>
      <div class="card-body">
        <ng-content *ngTemplateOutlet="content"></ng-content>
      </div>
    </div>

    <ng-template #content>
      <div class="row">
        <div class="col-md-12 ml-auto mr-auto">
          <div id="printId" class="col-lg-9 col-md-12 scrollit">
            <div [hover-class]="config('card_pres_entreprise')?.param2" *ngIf="annonce.pres_entreprise && config('card_pres_entreprise')?._view" class="card">
              <div [style]="safeCss(config('cards_colors')?.style)"*ngIf="config('title_card_pres_entreprise')?._view"
                   [class]="config('title_card_pres_entreprise')?.class ? 'card-header ' + config('title_card_pres_entreprise')?.class : 'card-header'">
                <h3 [class]="config('title_card_pres_entreprise')?.param1 ? 'card-title ' + config('title_card_pres_entreprise')?.param1 : 'card-title'">
                  {{config('title_card_pres_entreprise')?.txt}}
                </h3>
              </div>
              <div class="card-body">
                <p [innerHtml]="annonce.pres_entreprise"></p>
                <div *ngIf="annonce.video" videoID="video_id" theme="dark" rel="1" controls="1" showinfo="1" autoplay="0" mute="0" [hidden]="isNullOrEmpty(annonce.video)" class="youtube_player embed-responsive embed-responsive-16by9" [style]="safeCss(config('annonce_video')?.style)">
                  <iframe [src]='safeSrc' frameborder="0" allowfullscreen></iframe>
                </div>
              </div>
            </div>
            <div *ngIf="annonce.caract_poste && config('card_caract_poste')?._view" [hover-class]="config('card_caract_poste')?.param2" class="card" style="margin-top:5rem;">
              <div [style]="safeCss(config('cards_colors')?.style)"*ngIf="config('title_card_caract_poste')?._view"
                   [class]="config('title_card_caract_poste')?.class ? 'card-header ' + config('title_card_caract_poste')?.class : 'card-header'">
                <h3 [class]="config('title_card_caract_poste')?.param1 ? 'card-title ' + config('title_card_caract_poste')?.param1 : 'card-title'">
                  {{config('title_card_caract_poste')?.txt}}
                </h3>
              </div>
              <div class="card-body">
                <p [innerHtml]="annonce.caract_poste" class="ck-content"></p>
              </div>
            </div>
            <div *ngIf="annonce.autre_caract && config('card_autre_caract')?._view" [hover-class]="config('card_autre_caract')?.param2" class="card" style="margin-top:5rem;">
              <div [style]="safeCss(config('cards_colors')?.style)"*ngIf="config('title_card_autre_caract')?._view"
                   [class]="config('title_card_autre_caract')?.class ? 'card-header ' + config('title_card_autre_caract')?.class : 'card-header'">
                <h3 [class]="config('title_card_autre_caract')?.param1 ? 'card-title ' + config('title_card_autre_caract')?.param1 : 'card-title'">
                  {{config('title_card_autre_caract')?.txt}}
                </h3>
              </div>
              <div class="card-body">
                <p [innerHtml]="annonce.autre_caract"></p>
              </div>
            </div>
            <div *ngIf="annonce.contact_precision && config('card_contact_precision')?._view" [hover-class]="config('card_contact_precision')?.param2" class="card" style="margin-top:5rem;">
              <div [style]="safeCss(config('cards_colors')?.style)"*ngIf="config('title_card_contact_precision')?._view"
                   [class]="config('title_card_contact_precision')?.class ? 'card-header ' + config('title_card_contact_precision')?.class : 'card-header'">
                <h3 [class]="config('title_card_contact_precision')?.param1 ? 'card-title ' + config('title_card_contact_precision')?.param1 : 'card-title'">
                  {{config('title_card_contact_precision')?.txt}}
                </h3>
              </div>
              <div class="card-body">
                <p [innerHtml]="annonce.contact_precision"></p>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12 stackem">
            <div class="card ">
              <div [style]="safeCss(config('cards_colors')?.style)"*ngIf="config('title_card_infos')?._view"
                   [class]="config('title_card_infos')?.class ? 'card-header ' + config('title_card_infos')?.class : 'card-header'">
                <h3 [class]="config('title_card_infos')?.param1 ? 'card-title ' + config('title_card_infos')?.param1 : 'card-title'">
                  {{config('title_card_infos')?.txt}}
                </h3>
              </div>
              <div class="card-body">
                <div id="compinfos">
                  <div *ngIf="!isNullOrEmpty(annonce.ref) && config('infos_ref')?._view" class="row">
                    <div class="col-lg-12"><b>Ref :</b> {{ annonce.ref}}</div>
                  </div>
                  <div *ngIf="!isNullOrEmpty(annonce.fonction) && config('infos_fonction')?._view" class="row">
                    <div class="col-lg-12"><b>Fonction{{getMulti(annonce.fonction)}} :</b> {{ annonce.fonction}}</div>
                  </div>
                  <div *ngIf="!isNullOrEmpty(annonce.debut_diffusion) && config('infos_debut_diffusion')?._view" class="row">
                    <div class="col-md-12"><b>Date de publication :</b> {{ annonce.debut_diffusion | date: 'dd/MM/yyyy'}}</div>
                  </div>
                  <div *ngIf="!isNullOrEmpty(annonce.contrats) && config('infos_contrats')?._view" class="row">
                    <div class="col-lg-12"><b>Type de contrat{{getMulti(annonce.contrats)}} :</b> {{ annonce.contrats}}</div>
                  </div>
                  <div *ngIf="!isNullOrEmpty(annonce.regions) && config('infos_regions')?._view" class="row">
                    <div class="col-lg-12"><b>Localisation{{getMulti(annonce.regions)}} :</b> {{ annonce.regions}}</div>
                  </div>
                  <div *ngIf="annonce.nombre_postes > 0 && config('infos_nombre_postes')?._view" class="row">
                    <div class="col-lg-12"><b>Nombre de poste{{annonce.nombre_postes > 1 ? 's' : ''}} :</b> {{ annonce.nombre_postes}}</div>
                  </div>
                  <div *ngIf="!isNullOrEmpty(annonce.experience) && config('infos_experience')?._view" class="row">
                    <div class="col-lg-12"><b>Expérience :</b> {{ annonce.experience }} ans</div>
                  </div>
                  <div *ngIf="!isNullOrEmpty(annonce.expBas) && config('infos_expBas')?._view" class="row">
                    <div class="col-lg-12"><b>Expérience :</b> {{ annonce.experience }} <span [hidden]="!isNullOrEmpty(annonce.experienceHaut)">(minimum)</span><span [hidden]="isNullOrEmpty(annonce.experienceHaut)"> à {{ annonce.experienceHaut }}</span></div>
                  </div>
                  <div *ngIf="!isNullOrEmpty(annonce.date_embauche) && config('infos_date_embauche')?._view" class="row">
                    <div class="col-lg-12"><b>Date de début :</b> {{ annonce.date_embauche}}</div>
                  </div>
                  <div *ngIf="!isNullOrEmpty(annonce.statut) && annonce.statut !== 'Indifférent' && config('infos_statut')?._view" class="row">
                    <div class="col-lg-12"><b>Statut :</b> {{ annonce.statut }}</div>
                  </div>
                  <div *ngIf="!isNullOrEmpty(annonce.salaire) && config('infos_salaire')?._view" class="row">
                    <div class="col-lg-12"><b>Salaire :</b> {{ annonce.salaire }}</div>
                  </div>
                </div>
                <div *ngIf="config('btn_postuler')?._view" class="row">
                  <div class="col-12">
                    <button (click)="openDialog()" class="btn btn-rose mat-raised-button btn-post" mat-raised-button="" [style]="safeCss(config('btn_postuler')?.style)">
                      <span class="mat-button-wrapper">{{ config('btn_postuler')?.txt }}</span>
                      <div class="mat-button-ripple mat-ripple" matripple=""></div>
                      <div class="mat-button-focus-overlay"></div>
                    </button>
                  </div>
                </div>
                <div *ngIf="config('btn_envoi_ami_bis')?._view" class="row">
                  <div class="col-12">
                    <button (click)="openDialogSend()" class="btn btn-rose mat-raised-button btn-post" mat-raised-button="" [style]="safeCss(config('btn_envoi_ami_bis')?.style) ">
                      <span class="mat-button-wrapper">{{ config('btn_envoi_ami_bis')?.txt }}</span>
                      <div class="mat-button-ripple mat-ripple" matripple=""></div>
                      <div class="mat-button-focus-overlay"></div>
                    </button>
                  </div>
                </div>
                <div *ngIf="config('btn_return')?._view" class="row">
                  <div class="col-12">
                    <button (click)="announcesReturn()" _ngcontent-cfq-c3="" class="btn btn-rose mat-raised-button btn-post" mat-raised-button="" [style]="safeCss(config('btn_return')?.style)">
                      <span class="mat-button-wrapper">{{ config('btn_return')?.txt }}s</span>
                      <div class="mat-button-ripple mat-ripple" matripple=""></div>
                      <div class="mat-button-focus-overlay"></div>
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <section class="ss-icon">
 
                      <a *ngIf="config('social_linkedin')?._view" href="" (click)="linkedinShare()"><article [style]="safeCss(config('social_linkedin')?.style)"><span >linkedin</span></article></a>
                      <a *ngIf="config('social_fb')?._view" href="" (click)="facebookShare()"><article [style]="safeCss(config('social_fb')?.style)"><span style="font-family: 'SSSocial' !important">facebook</span></article></a>
                      <a *ngIf="config('social_twitter')?._view" href="" (click)="twitterShare()"><article article [style]="safeCss(config('social_twitter')?.style)"><span style="font-family: 'SSSocial' !important">twitter</span></article></a>
                      <a *ngIf="config('social_tumblr')?._view" href="" (click)="tumblrShare()"><article><span style="font-family: 'SSSocial' !important">tumblr</span></article></a>
                      <a *ngIf="config('social_blogger')?._view" href="" (click)="bloggerShare()"><article><span style="font-family: 'SSSocial' !important">blogger</span></article></a>
                    </section>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 marge-top">
                    <section class="ss-icon">
                      <a *ngIf="config('btn_imprimer')?._view"
                         href=""
                         matTooltip="Imprimer cette annonce"
                         matTooltipPosition="above"
                         (click)="print()">
                        <article [style]="safeCss(config('btn_imprimer')?.style)">
                          <span [style]="safeCss(config('btn_imprimer')?.param1)">
                            <i [class]="config('btn_imprimer')?.icon"></i>
                          </span>
                        </article>
                      </a>
                      <a *ngIf="config('btn_envoi_ami')?._view"
                         href=""
                         matTooltip="Envoi de l'offre par mail ou sms"
                         matTooltipPosition="above"
                         (click)="openDialogSend()">
                        <article [style]="safeCss(config('btn_envoi_ami')?.style)">
                          <span [style]="safeCss(config('btn_envoi_ami')?.param1)">
                            <i [class]="config('btn_envoi_ami')?.icon"></i>
                          </span>
                        </article>
                      </a>
                    </section>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12" *ngIf="annonce.code_postal">
                    <here-map #map
                              appKey="aHtfU0V_4Y-N19VH2R-DpH3vyQwPL8QQdHDiiWD21dw"
                              lat="{{lat}}"
                              lng="{{lng}}"
                              width="100%"
                              height="25vh">
                    </here-map>
                  </div>
                </div>
              </div>
            </div>
            <div class="fixed">
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
<footer id="urlprint" class="footerPrint" style="display: none;">{{ url }}{{ router.url }}</footer>

<script type="application/ld+json">
  {
    "@context" : "https://schema.org/",
    "@type" : "JobPosting",
    "title" : "{{ annonce.intitule}}",
    "description" : "
    <p>{{ annonce.presentation }}<br><br>{{ annonce.caracteristiques }}<br><br>{{ annonce.profil }}</p>",
    "identifier": {
    "@type": "PropertyValue",
    "name": "{{ annonce.societe }}",
    "value": "{{ annonce.id }}"
  },
    "datePosted" : "{{ annonce.debut }}",
    "validThrough" : "{{ annonce.fin }}",
    "employmentType" : "CONTRACTOR",
    "hiringOrganization" : {
    "@type" : "Organization",
    "name" : "{{ annonce.societe }}",
    "sameAs" : "{{ this.location.path() }}",
    "logo" : "http://www.example.com/images/logo.png"
  },
    "jobLocation": {
    "@type": "Place",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "{{ annonce.adresse }}",
      "addressLocality": ", {{ annonce.ville }}",
      "addressRegion": "{{ annonce.lieu }}",
      "postalCode": "{{ annonce.cp }}",
      "addressCountry": "FR"
    }
  },
    "baseSalary": {
      "@type": "MonetaryAmount",
      "currency": "EUR",
      "value": {
        "@type": "QuantitativeValue",
        "value": "{{ salaireHaut | iif: salaireHaut : salaireBas }}",
        "unitText": "YEAR"
      }
    }
  }
</script>
